(function(){
    var StickyScroller = function (p, s) {

        this.parent = p
        this.sticker = s

        this.divHeight = this.parent.clientHeight
        this.divStart = this.parent.getBoundingClientRect().top
        this.scrollPos = this.parent.scrollTop

        this.stickerHeight = this.sticker.clientHeight
        this.stickerStart = this.sticker.getBoundingClientRect().top

        setPos(this)

        var that = this

        this.parent.addEventListener('scroll', function(e) {
            that.scrollPos = that.parent.scrollTop
            that.stickerPos = that.sticker.getBoundingClientRect().top

            setPos(that)
        })
    }

    function setPos(options) {
        //console.log(options)
        if(options.scrollPos <= options.stickerStart-options.divStart-options.divHeight+options.stickerHeight) {
            options.sticker.style.position = "absolute"
            options.sticker.style.top = (options.divHeight - options.stickerHeight) + "px"
        } else if(options.scrollPos >= options.stickerStart-options.divStart) {
            options.sticker.style.position = "absolute"
            options.sticker.style.top = (0) + "px"
        } else {
            options.sticker.style.position = "inherit"
        }
    }

    window.StickyScroller = StickyScroller
})()
/*
let div = document.getElementById('container')
let sticker = document.getElementById('sticker')

var ss = new window.StickyScroller(div, sticker)
*/
